import { dcChargingPortGroups } from "./component-ports";
import type { ComponentDefinition } from "./types";

/** Electronic charger ceiling for one positive DC output terminal.
 * Imported custom metadata is untrusted: only finite nonnegative limits on
 * actual DC charging ports count. Connector ampacity never regulates output. */
export function outputPortCurrent(
  def: ComponentDefinition,
  positiveTerminalId: string,
  stageCurrent: number,
): number {
  const limits: unknown = def.outputCurrentLimitsA;
  if (def.category !== "charger" || !limits || typeof limits !== "object" || Array.isArray(limits) ||
      !Object.hasOwn(limits, positiveTerminalId) ||
      !dcChargingPortGroups(def).some(port => port.some(t => t.id === positiveTerminalId && t.polarity === "positive"))) return stageCurrent;
  const limit: unknown = (limits as Record<string, unknown>)[positiveTerminalId];
  return typeof limit === "number" && Number.isFinite(limit) && limit >= 0
    ? Math.min(stageCurrent, limit) : stageCurrent;
}

/** Apply each output's ceiling to its positive and matching return. A common
 * return may carry several ports, still bounded by the one aggregate stage. */
export function outputTerminalCurrent(
  def: ComponentDefinition,
  terminalId: string,
  stageCurrent: number,
): number {
  const ports = dcChargingPortGroups(def).filter(port => port.some(t => t.id === terminalId));
  if (ports.length === 0) return stageCurrent;
  return Math.min(stageCurrent, ports.reduce((sum, port) => {
    const positive = port.find(t => t.polarity === "positive")!;
    return sum + outputPortCurrent(def, positive.id, stageCurrent);
  }, 0));
}
